import { ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';

const categoryAnalyticMapper = {
  [ESuburbanEstimationCategory.HouseSale]: 'MyHomeHouse',
  [ESuburbanEstimationCategory.LandSale]: 'MyHomeLand',
};

export function getCategoryAnalytics(suburbanType?: ESuburbanEstimationCategory) {
  if (suburbanType) {
    return categoryAnalyticMapper[suburbanType];
  }

  return 'MyHomeFlat';
}
